// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__FgC5d","errorLogs":"styles_errorLogs__62JDU"};